"use strict";

var _interopRequireDefault = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _sideNav = _interopRequireDefault(require("@/components/side-nav.vue"));
var _footNav = _interopRequireDefault(require("@/components/foot-nav"));
var _merchant_form = _interopRequireDefault(require("@/components/form/merchant_form.vue"));
var _appCitysData = _interopRequireDefault(require("@/assets/static/js/citys/app.citys.data.js"));
var _api = require("../../api/api");
var _vueSeamlessScroll = _interopRequireDefault(require("vue-seamless-scroll"));
var _default = exports.default = {
  name: 'chemicalMall',
  components: {
    footNav: _footNav.default,
    sideNav: _sideNav.default,
    merchantForm: _merchant_form.default,
    vueSeamlessScroll: _vueSeamlessScroll.default
  },
  data: function data() {
    return {
      citys: _appCitysData.default.cityDataWithoutDistrict,
      //出发城市数据
      classOption: {
        direction: 2,
        limitMoveNum: 6
      },
      //合作伙伴滚动配置
      partners: [{
        icon: require("../../assets/static/img/ouyeel/1.jpg"),
        name: '武汉平煤武钢联合焦化有限责任公司'
      }, {
        icon: require("../../assets/static/img/ouyeel/2.jpg"),
        name: '鞍钢集团化工事业部'
      }, {
        icon: require("../../assets/static/img/ouyeel/3.jpg"),
        name: '宁夏宝丰能源集团有限公司'
      }, {
        icon: require("../../assets/static/img/ouyeel/4.jpg"),
        name: '山西焦化股份有限公司'
      }, {
        icon: require("../../assets/static/img/ouyeel/5.jpg"),
        name: '内蒙古庆华集团有限公司'
      }, {
        icon: require("../../assets/static/img/ouyeel/6.jpg"),
        name: '上海巨盛化工有限公司'
      }, {
        icon: require("../../assets/static/img/ouyeel/1.jpg"),
        name: '武汉平煤武钢联合焦化有限责任公司'
      }],
      products: [{
        icon: require("../../assets/static/img/chemicalMall/03.png"),
        name: '煤焦油'
      }, {
        icon: require("../../assets/static/img/chemicalMall/04.png"),
        name: '粗苯'
      }, {
        icon: require("../../assets/static/img/chemicalMall/05.png"),
        name: '稀氨水'
      }, {
        icon: require("../../assets/static/img/chemicalMall/06.png"),
        name: '洗油'
      }, {
        icon: require("../../assets/static/img/chemicalMall/07.png"),
        name: '粗酚'
      }, {
        icon: require("../../assets/static/img/ouyeel/liqing.png"),
        name: '固体沥青'
      }],
      mallRules: {
        category: [{
          required: true,
          message: '请选择分类',
          trigger: 'change'
        }],
        cityValue: [{
          required: true,
          message: '请选择所在城市',
          trigger: 'change'
        }],
        concactPhone: [{
          required: true,
          message: '请输入电话号码',
          trigger: 'blur'
        }, {
          pattern: /^1\d{10}$/,
          message: '请输入正确的手机号',
          trigger: 'blur'
        }],
        contactName: [{
          required: true,
          message: '请输入联系人姓名',
          trigger: 'change'
        }],
        title: [{
          required: true,
          message: '请输入标题名称',
          trigger: 'change'
        }],
        content: [{
          required: true,
          message: '请输入具体内容~',
          trigger: 'change'
        }]
      },
      mallForm: {
        category: '卖货信息',
        //分类
        cityValue: [],
        //所在城市
        province: '',
        city: '',
        contactName: '',
        //联系人姓名
        contactPhone: '',
        //联系人电话
        title: '',
        //标题名称
        content: ''
      },
      classifyData: [],
      //危化商铺分类数据
      plateId: '',
      //危化商铺板块Id
      classifyId: '' //危化商铺分类Id
    };
  },
  created: function created() {
    this.getClassifyData();
  },
  methods: {
    //选择出发城市
    startCityChange: function startCityChange(value) {
      if (value.length > 0) {
        this.mallForm.province = value[0];
      }
      if (value.length > 1) {
        this.mallForm.city = value[1];
      }
      this.mallForm.cityValue = value;
    },
    // 提交并校验
    submitForm: function submitForm(formName) {
      var _this = this;
      var that = this;
      that.$refs[formName].validate( /*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(valid, obj) {
          var key;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (!valid) {
                  _context.next = 4;
                  break;
                }
                _this.saveFormData();
                _context.next = 8;
                break;
              case 4:
                console.log('error submit!!', obj);
                // 取错误信息对象里的第一个数组,抛出错误提示
                key = Object.keys(obj)[0];
                _this.$message({
                  message: obj[key][0].message,
                  type: 'error',
                  duration: '3000'
                });
                return _context.abrupt("return", false);
              case 8:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    saveFormData: function () {
      var _saveFormData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var jsonParam, _yield$apiSaveMerchan, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              jsonParam = {
                jsonParamete: JSON.stringify({
                  fun: "saveMchInfo",
                  param: {
                    merchantId: "",
                    plateId: this.plateId,
                    classifyId: this.classifyId,
                    province: this.mallForm.province,
                    city: this.mallForm.city,
                    contactPerson: this.mallForm.contactName,
                    contactPhone: this.mallForm.contactPhone,
                    title: this.mallForm.title,
                    content: this.mallForm.content,
                    longitude: "",
                    latitude: "",
                    sourceType: 6,
                    picUrl: ""
                  },
                  version: 1
                })
              };
              _context2.next = 3;
              return (0, _api.apiSaveMerchantInfo)(jsonParam);
            case 3:
              _yield$apiSaveMerchan = _context2.sent;
              data = _yield$apiSaveMerchan.data;
              if (data.proCode == '200') {
                this.mallForm.province = '';
                this.mallForm.city = '';
                //清空选择器的节点信息
                this.$refs.city.$refs.panel.clearCheckedNodes();
                this.$refs['svForm'].resetFields();
                // 重置表单后,plateId和classifyId也要重置
                this.getClassifyData();
                this.$message({
                  message: '提交成功',
                  type: 'success',
                  duration: '1000'
                });
              }
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function saveFormData() {
        return _saveFormData.apply(this, arguments);
      }
      return saveFormData;
    }(),
    //获取危化商铺板块分类数据
    getClassifyData: function () {
      var _getClassifyData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var jsonParam, _yield$apiGetPlateCla, data, plateData;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              jsonParam = {
                jsonParamete: JSON.stringify({
                  fun: "getplateclassifybycode",
                  param: {
                    plateCode: 'HGMY',
                    classifyCode: ""
                  },
                  version: 1
                })
              };
              _context3.next = 3;
              return (0, _api.apiGetPlateClassifyData)(jsonParam);
            case 3:
              _yield$apiGetPlateCla = _context3.sent;
              data = _yield$apiGetPlateCla.data;
              if (data.proCode == '200') {
                plateData = data.proData;
                this.getPlateClassifyIdWithPlateData(plateData);
              }
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getClassifyData() {
        return _getClassifyData.apply(this, arguments);
      }
      return getClassifyData;
    }(),
    //获取板块ID和分类ID
    getPlateClassifyIdWithPlateData: function getPlateClassifyIdWithPlateData(plateData) {
      var _this2 = this;
      if (plateData.length > 0) {
        //获取板块ID
        var plateObj = plateData[0];
        this.plateId = plateObj.plateId;
        //获取分类ID
        this.classifyData = plateObj.plateClassifies;
        if (this.classifyData.length > 0) {
          var classifyObj = this.classifyData.find(function (item) {
            return item.classifyName == _this2.mallForm.category;
          });
          this.classifyId = classifyObj.classifyId;
          this.mallForm.category = classifyObj.classifyName;
        }
      }
    }
  }
};